import React from "react";

const formatNumber = (value) =>
  Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

const formatCurrency = (value) =>
  `$ ${Number(value || 0).toLocaleString("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const THEMES = {
  blue: {
    bg: "bg-[#EAF4FF]",
    border: "border-[#B7D6F5]",
    label: "text-[#3B82C4]",
    value: "text-[#2563A8]",
  },
  green: {
    bg: "bg-[#EAF8F0]",
    border: "border-[#B7E0C8]",
    label: "text-[#3D9B6A]",
    value: "text-[#2D7A52]",
  },
  pink: {
    bg: "bg-[#FDECEC]",
    border: "border-[#F5C2C2]",
    label: "text-[#E06B6B]",
    value: "text-[#C94A4A]",
  },
};

export default function SummaryStatCards({ items = [] }) {
  return (
    <div className="flex justify-end flex-wrap gap-2.5 mb-4">
      {items.map((item) => {
        const theme = THEMES[item.theme] || THEMES.blue;
        const displayValue = item.isCurrency
          ? formatCurrency(item.value)
          : formatNumber(item.value);

        return (
          <div
            key={item.label}
            className={`inline-flex items-center px-4 py-2 rounded-md border ${theme.bg} ${theme.border}`}
          >
            <span
              className={`text-[13px] font-medium uppercase whitespace-nowrap ${theme.label}`}
            >
              {item.label}:{" "}
              <span className={`font-bold ${theme.value}`}>{displayValue}</span>
            </span>
          </div>
        );
      })}
    </div>
  );
}
